import * as microsoftTeams from '@microsoft/teams-js'

let _title = ''

function updateMicrosoftTeams(title) {
	_title = title
	setValidityState(!!_title)
}

function initializeMicrosoftTeams(tabUrl, title) {
	microsoftTeams.initialize()
	updateMicrosoftTeams(title)
	microsoftTeams.settings.registerOnSaveHandler(function(saveEvent) {
		microsoftTeams.settings.setSettings({
			entityId: tabUrl,
			contentUrl: tabUrl,
			suggestedDisplayName: _title,
			websiteUrl: tabUrl,
		})
		saveEvent.notifySuccess()
	})
}

function setValidityState(isValid) {
	microsoftTeams.settings.setValidityState(isValid)
}


export {
	initializeMicrosoftTeams,
	updateMicrosoftTeams,
	setValidityState,
}
